export const heroImageSlider = () => {
	const sliders = document.querySelectorAll(
		".hero-banner-image .media-image"
	);

	if (!sliders.length) return;

	sliders.forEach((slider) => {
		const slides = Array.from(
			slider.querySelectorAll(":scope > .wp-block-image")
		);

		if (slides.length < 2) return;

		let currentIndex = 0;
		let intervalId = null;
		let isAnimating = false;

		slides.forEach((slide, index) => {
			slide.classList.remove(
				"is-active",
				"is-entering",
				"is-leaving"
			);

			slide.setAttribute("aria-hidden", index === 0 ? "false" : "true");

			if (index === 0) {
				slide.classList.add("is-active");
			}
		});

		const changeSlide = () => {
			if (isAnimating) return;

			isAnimating = true;

			const currentSlide = slides[currentIndex];
			const nextIndex = (currentIndex + 1) % slides.length;
			const nextSlide = slides[nextIndex];

			nextSlide.classList.remove("is-leaving");
			nextSlide.classList.add("is-entering");
			nextSlide.setAttribute("aria-hidden", "false");

			requestAnimationFrame(() => {
				nextSlide.classList.add("is-active");

				requestAnimationFrame(() => {
					currentSlide.classList.add("is-leaving");
					currentSlide.classList.remove("is-active");
				});
			});

			window.setTimeout(() => {
				currentSlide.classList.remove("is-leaving");
				currentSlide.setAttribute("aria-hidden", "true");

				nextSlide.classList.remove("is-entering");

				currentIndex = nextIndex;
				isAnimating = false;
			}, 550);
		};

		const startSlider = () => {
			if (intervalId) return;

			intervalId = window.setInterval(changeSlide, 2500);
		};

		const stopSlider = () => {
			if (!intervalId) return;

			window.clearInterval(intervalId);
			intervalId = null;
		};

		startSlider();

		slider.addEventListener("mouseenter", stopSlider);
		slider.addEventListener("mouseleave", startSlider);

		document.addEventListener("visibilitychange", () => {
			if (document.hidden) {
				stopSlider();
			} else {
				startSlider();
			}
		});
	});
};
